import { FC } from 'react';

import { useCompanyBankAccounts } from 'common/hooks/useCompanyBankAccounts';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import BackButton from 'components/BackButton';
import { BankAccountRow } from 'components/BankAccountRow';
import ErrorView from 'components/ErrorView';
import Loader from 'components/Loader';
import { StepProps } from 'components/Stepper/types';
import TrackView from 'features/Analytics/TrackView';
import * as StepperLayout from 'layouts/StepperLayout';

import * as CommonStyles from '../../common/styles';
import { useMandateCreationFlowContext } from '../../hooks/useMandateCreationFlowContext';
import locales from './locales';

export const SelectFromBankAccount: FC<StepProps> = ({ goBack, goNext }) => {
  const { bankAccounts, error, loading } = useCompanyBankAccounts();
  const { setSharedState, sharedState } = useMandateCreationFlowContext();
  const { mandate } = sharedState;

  if (error) {
    return <ErrorView />;
  }

  const handleBankAccountClick = (bankAccountId: string) => {
    setSharedState({
      ...sharedState,
      mandate: {
        ...mandate,
        bankAccountId,
      },
    });
    goNext();
  };

  return (
    <StepperLayout.Root>
      <TrackView pageName="SelectFromBankAccount" />
      <StepperLayout.Body>
        <CommonStyles.HeaderContainer>
          <BackButton onClick={goBack} />
        </CommonStyles.HeaderContainer>
        <StepperLayout.BodyScrollableSection>
          <Heading marginBottom="space-32" size="lg">
            {locales.fromAccount}
          </Heading>
          {loading ? (
            <Loader />
          ) : (
            <SunshineCard.Group>
              {bankAccounts.map((bankAccount) => (
                <BankAccountRow
                  bankAccount={bankAccount}
                  key={bankAccount.bankAccountId}
                  onClick={() =>
                    handleBankAccountClick(bankAccount.bankAccountId)
                  }
                />
              ))}
            </SunshineCard.Group>
          )}
        </StepperLayout.BodyScrollableSection>
      </StepperLayout.Body>
    </StepperLayout.Root>
  );
};
